export default class Modal {
	constructor() {
		document.addEventListener("click", function (event) {
			if (event.target.classList.contains("button--modal")) {
				var content = document.querySelector(event.target.hash);
				content.classList.add("show");
				document.body.style.overflow = "hidden";
				event.preventDefault();
			} else if (
				event.target.parentNode.classList.contains(
					"button--modal-close"
				) ||
				event.target.classList.contains("button--modal-close")
			) {
				var modals = document.querySelectorAll(".modal-wrapper");
				for (var i = 0; i < modals.length; i++) {
					modals[i].classList.remove("show");
				}
				document.body.style.overflow = "scroll";
				event.preventDefault();
			} else {
				return;
			}
		});
	}
}
